// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "GeneralView" + "." + "32a99263f038199ecb86" + ".js";
};